<template>
	<div>
		<b-row>
			<b-col>
				<b-card>
					<div slot="header">
						{{ $t(`currency.title`) }}
						<div class="card-header-actions">
							<b-link
								@click="createOrUpdate()"
								class="card-header-action btn-setting"
								style="font-size: 15px"
								v-if="$can('create/edit', 'currency-rate')"
							>
								<i class="fa fa-plus-circle"></i>
							</b-link>
						</div>
					</div>
					<b-card-body>
						<div class="generalTableClass">
							<table class="table b-table table-bordered table-striped table-hover">
								<thead>
								<tr>
									<th>№</th>
									<th>{{ $t('incomes.date') }}</th>
									<th v-for="tmp in currency">{{ tmp }}</th>
									<th>{{ $t('incomes.actions') }}</th>
								</tr>
								</thead>
								<tbody>
								<tr
									v-for="(listItem, index) in items"
									:key="`currency-rate-row-${index}`"
								>
									<td>{{ paginate(index, page, perPage) }}</td>
									<td>{{ listItem.date }}</td>
									<td v-for="(tmp,idx) in currency" :key="idx">
										<span v-for="(l, i) in listItem.rates" :key="`rates-${i}`">
											<span v-if="l.currencyCode == tmp">{{ l.rate ? l.rate : '' }}</span>
										</span>
									</td>
									<td class="table_actions min-60">
										<!-- EDIT BUTTON -->
										<b-link
											v-if="$can('create/edit', 'currency-rate')"
											@click="createOrUpdate(true, listItem)"
										>
											<i class="fa fa-edit"></i>
										</b-link>

										<!-- DELETE BUTTON -->
										<b-link
											v-if="$can('delete', 'currency-rate')"
											:id="`currency-rate-delete-${listItem.id}-${index}`"
										>
											<i class="fa fa-trash"></i>
											<!--											deleteById(listAllId(listItem.rates))-->
										</b-link>
										<!-- POPOVER TO CONFIRM DELETING THE REFERENCE -->
										<div>
											<b-popover
												:key="listItem.id + 'popover'"
												:target="`currency-rate-delete-${listItem.id}-${index}`"
												placement="bottom"
												:ref="`popover-delete-${index}`"
												class="refDeleteConfirm"
											>
												<template slot="title">
													<b-button @click="closePopover(index)" class="close"
															  aria-label="Close" style="margin-left: 5px">
														<span class="d-inline-block" aria-hidden="true">&times;</span>
													</b-button>
													{{ $t('want_to_delete?') }}
												</template>

												<div>
													<!--<b-link @click="onClose" size="sm" variant="danger">Yo'q</b-link>
                                                    <b-link @click="onOk" size="sm" variant="primary">Ha</b-link>-->
													<div class="row mt-1">
														<div class="col-6">
															<b-button variant="outline-danger" size="sm" block
																	  @click="closePopover(index)"
															> {{ $t('words.no') }}
															</b-button>
														</div>
														<div class="col-6">
															<b-button variant="outline-success" size="sm" block
																	  @click="deleteById(listItem.rates, index)">{{
																	$t('words.yes')
																}}
															</b-button>
														</div>
													</div>
												</div>
											</b-popover>

										</div>
									</td>
								</tr>
								</tbody>
							</table>
							<nav>
								<b-pagination
									:total-rows="total"
									:per-page="perPage"
									v-model="page"
									:prev-text="$t('pagination.prev')"
									:next-text="$t('pagination.next')"
									hide-goto-end-buttons
								/>
							</nav>
						</div>

					</b-card-body>
				</b-card>
			</b-col>
		</b-row>

		<!-- CREATE/UPDATE MODAL -->
		<b-modal
			v-model="modal"
			@cancel="itemInit"
			:title="$t('currency.new-rate')"
		>
			<div>
				<ValidationObserver
					ref="currencyRateObserver"
					v-slot="{}"
				>
					<ValidationProvider
						name="Date"
						rules="required"
						v-slot="{errors}"
					>
						<b-form-group
							class="required"
							:state="errors.length <= 0"
							invalid-feedback="Bu maydon majburiy"
						>

							<date-picker
								v-model="currencyRatePayload.date"
								lang="ru"
								size="sm"
								class="pl-0"
								placeholder="dd-mm-yyyy"
								valueType="format"
								format="DD-MM-YYYY"
							></date-picker>
						</b-form-group>
					</ValidationProvider>
					<b-row>
						<b-col cols="6">
							<p>Разница в UZS</p>
							<ValidationProvider
								v-for="(eachRate, index) in currencyRatePayload.rates"
								:key="`currency-rate-create-${eachRate.currencyId}-${index}`"
								:name="`currency-rate-create-${eachRate.currencyId}-${index}`"
								rules="required"
								v-slot="{ errors }"
							>
								<b-form-group
									v-show="eachRate.currencyCode != 'UZS'"
									breakpoint="lg"
									class="required"
									:state="errors.length <= 0"
									invalid-feedback="Bu maydon majburiy"
									size="sm"
								>
									<b-input-group size="sm">
										<b-form-input
											:required="true"
											:disabled="eachRate.currencyCode == 'UZS'"
											:placeholder="eachRate.currencyName"
											size="sm"
											type="number"
											@focus="$event.target.select()"
											v-model.number="eachRate.rate"
										/>
										<b-input-group-addon>
											<b-button
												disabled
												size="sm"
											>{{ eachRate.currencyName }}
											</b-button>
										</b-input-group-addon>
									</b-input-group>
								</b-form-group>
							</ValidationProvider>
						</b-col>
						<b-col cols="6">
							<p>Разница в EUR</p>
							<ValidationProvider
								v-for="(eachRate, index) in currencyRatePayload.rates"
								:key="`currency-rate-create-${eachRate.currencyId}-${index}`"
								:name="`currency-rate-create-${eachRate.currencyId}-${index}`"
								rules="required"
								v-slot="{ errors }"
							>
								<b-form-group
									v-show="eachRate.currencyCode != 'UZS'"
									breakpoint="lg"
									class="required"
									:state="errors.length <= 0"
									invalid-feedback="Bu maydon majburiy"
									size="sm"
								>
									<b-input-group size="sm">
										<b-form-input
											:required="true"
											:disabled="eachRate.currencyCode == 'EUR'"
											:placeholder="eachRate.currencyName"
											size="sm"
											type="number"
											@focus="$event.target.select()"
											v-model.number="eachRate.ratioToDepCurrencyRate"
										/>
										<b-input-group-addon>
											<b-button
												disabled
												size="sm"
											>{{ eachRate.currencyName }}
											</b-button>
										</b-input-group-addon>
									</b-input-group>
								</b-form-group>
							</ValidationProvider>
						</b-col>
					</b-row>

				</ValidationObserver>
			</div>
			<div slot="modal-footer">
				<div>
					<b-button
						variant="outline-danger"
						@click="modal = !modal"
					>{{ $t('cancel') }}
					</b-button>
					<b-button
						variant="outline-primary"
						@click="save"
						class="ml-3"
					>{{ $t('save') }}
					</b-button>
				</div>
			</div>
		</b-modal>
	</div>
</template>

<script>
import {mapActions, mapState} from 'vuex'
import {ValidationObserver, ValidationProvider} from 'vee-validate'
import UsersService from "../../services/users.sevice";
import CurrencyService from "../../services/currency.service";

const item = {
	id: null,
	departmentId: null,
	rateUsd: null
};

export default {
	name: 'Currencies',

	components: {
		ValidationObserver,
		ValidationProvider
	},

	data() {
		return {
			isDelete: false,
			currencyRatePayload: {
				rates: [],
				date: ''
			},
			items: [],
			currency: [
				'USD',
				'EUR',
				'RUB',
				'GBP',
				'CNY'
			],
			page: 1,
			perPage: 20,
			total: 0,
			modal: false,
			mode: 'create',
			departments: [],
			item: {
				id: null,
				departmentId: null,
				rateUsd: null
			},
			test: [
				{
					id: 100,
					date: '15-04-2021',
					eur: 14000,
					usd: 10500,
					gbp: 18000,
					cny: 18000,
					rub: 200
				}
			]
		}
	},
	methods: {
		...mapActions('references', [
			'getReferenceChildren'
		]),
		closePopover(index) {
			const refName = `popover-delete-${index}`;
			this.$refs[refName][0].$emit('close')
		},
		deleteById(rates, index) {
			CurrencyService.deleteById(rates)
				.then(response => {
					this.closePopover(index)
					this.loadItems();
				})
				.catch(e => {
					let errMsg = 'Please, try again...'
					if (e.request && e.request.response) {
						let response = JSON.parse(e.request.response);
						errMsg = response.message;
					}
					this.$vs.notify({
						title: errMsg,
						color: 'danger',
						icon: 'close',
						position: 'top-right'
					});
				})
		},
		getToday() {
			let today = new Date();
			var dd = String(today.getDate()).padStart(2, '0');
			var mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
			var yyyy = today.getFullYear();

			today = dd + '-' + mm + '-' + yyyy;

			return today;
		},
		makeCurrencyRateJson(forEdit = false, editingItem) {
			// RESET
			this.currencyRatePayload.rates = []
			if (forEdit) {
				/*this.refCurrencies.forEach(currency => {
					let tmp = {
						id: editingItem.id,
						currencyId: currency.id,
						currencyCode: currency.code,
						currencyName: currency.name,
						rate: currency.code == 'UZS' ? 1 : (Object.keys(editingItem).find(k => k == currency.code.toLowerCase()) ? editingItem[Object.keys(editingItem).find(k => k == currency.code.toLowerCase())] : null)

					}
					this.currencyRatePayload.rates.push(tmp)
				})
				this.currencyRatePayload.date = editingItem.date*/
				this.currencyRatePayload = Object.assign({}, editingItem)
			} else {
				this.refCurrencies.forEach(currency => {
					let tmp = {
						currencyId: currency.id,
						currencyCode: currency.code,
						currencyName: currency.name,
						rate: currency.code == 'UZS' ? 1 : null,
						ratioToDepCurrencyRate: currency.code == 'EUR' ? 1 : null
					}
					if (currency.code != 'UZS') {
						this.currencyRatePayload.rates.push(tmp)
					}
				})
				this.currencyRatePayload.date = this.getToday()
			}
		},
		async createOrUpdate(forUpdate = false, editingItem = {}) {
			await this.getReferenceChildren('CURRENCY')
			await this.makeCurrencyRateJson(forUpdate, editingItem)
			setTimeout(() => {
				this.$refs.currencyRateObserver.reset()
			}, 40)
			if (this.currencyRatePayload.date) {
				this.modal = true
			} else {
				this.$vs.notify({
					title: 'THIS FEATURE IS WIP',
					color: 'warning',
					icon: 'close',
					position: 'top-right'
				});
			}
		},
		/**
		 *
		 */
		fetchPermissions() {
			if (this.$can('get', 'permitted departments')) {
				UsersService.getPermittedDepartments().then(response => {
					this.departments = response.data.permittedDepartments;

				})
			}
		},
		itemInit() {
			Object.assign(this.item, item)
		},
		loadItems() {
			CurrencyService.fetch({
				page: this.page,
				limit: this.perPage
			}).then(response => {
				this.items = response.data.items;
				this.total = response.data.total;
			})
		},
		save() {
			this.$refs.currencyRateObserver.validate().then(valid => {
				if (valid) {
					CurrencyService.save(this.currencyRatePayload)
						.then(response => {
							this.modal = false;
							this.currencyRatePayload.rates = [];
							this.currencyRatePayload.date = '';
							this.loadItems();
						})
						.catch(e => {
							let errMsg = 'Please, try again...'
							if (e.request && e.request.response) {
								let response = JSON.parse(e.request.response);
								errMsg = response.message;
							}
							this.$vs.notify({
								title: errMsg,
								color: 'danger',
								icon: 'close',
								position: 'top-right'
							});
						})

				}
			})
		},
		paginate(index, page_size, page_number) {
			--page_size;
			return (page_number * page_size) + index + 1;
		}
	},

	created() {
		// await this.fetchPermissions();
		this.loadItems();
	},

	computed: {
		...mapState(['userDepCurrencyName']),
		...mapState('references', [
			'refCurrencies'
		]),
		withParents() {
			return this.departments.filter(item => {
				if (item.typeName === 'COMPANY')
					return item
			})
		},
	},

	watch: {
		'page': {
			handler() {
				this.loadItems();
			}
		}
	}
}
</script>

<style scoped>
</style>
